type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'ClientApplicationUser'
const nameSource = '/users/clientsApplicationsUsers'
const namePageTitle = 'ClientsApplicationsUsers'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'ClientsApplicationsUsers',
  to: '/users/clientsApplicationsUsers',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/users/clientsApplicationsUsers/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/users/clientsApplicationsUsers/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/users/clientsApplicationsUsers/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
